import React from 'react';
import Style from './sidebarStyle.module.scss';
import SidebarItems from './sidebar_items';
import LogoPatchifi from '../../images/NewLogo.svg';

const Sidebar = () => {
  return (
    <div
      //className="h-screen w-64  text-white flex flex-col"
      className={Style.sidebar_layout}
    >
      {/* Sidebar Header */}
      {/* <div className="p-4 text-xl font-bold border-b border-blue-500"> */}
      <div
        style={{
          position: 'relative', // Ensure the parent container positions relative
          padding: '2px',
        }}
      >
        <img
          src={LogoPatchifi}
          className="errorImage img-fluid"
          alt="logo"
          style={{
            // position: 'absolute', // Position the image independently
            // top: '20px', // Move it downward
            // left: '100px', // Move it to the right
            width: '240px', // Adjust the size of the image
            height: '50px',
            marginLeft: '-15px',
            // left: '50px', // Adjust left spacing
            // marginTop: '-15px',
          }}
        />
      </div>
      <div
        className={Style.content_layout}
        style={{
          // position: 'absolute', // Position the image independently
          // marginTop: '40px', // Move it downward
          width: '280px',
        }}
      >
        <SidebarItems></SidebarItems>
      </div>
    </div>
  );
};

export default Sidebar;
